export default __webpack_public_path__ + "static/media/shredded-mozzarella-cheese.c1820048.jpg";